module.exports = __webpack_public_path__ + "static/media/venetia-placuta.eb03365c.png";